export enum CallRoute {
    Outgoing = 'outgoing',
    Incoming = 'incoming',
}